/** Skeleton do modo ditado (§4c). */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-3xl animate-pulse flex-col gap-6">
      <div className="h-16 rounded-xl bg-slate-100" />
      <div className="h-40 rounded-2xl border border-slate-200 bg-white" />
      <div className="h-24 rounded-2xl border border-slate-200 bg-white" />
    </div>
  );
}
